/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { R as RadioButton, d as defineCustomElement$1 } from './radio-button.js';

const CalciteRadioButton = RadioButton;
const defineCustomElement = defineCustomElement$1;

export { CalciteRadioButton, defineCustomElement };

//# sourceMappingURL=calcite-radio-button.js.map